import { takeLatest } from "redux-saga/effects";
import { createBrowserHistory } from "history";

import { actions } from "./ducks";
import { auth, getShareToken } from "services/api/auth";
import { decodeJwt, deleteAuthData, setToken } from "helpers/jwt";
import { requestMiddleware } from "helpers/api";
import { updateProvidersToken } from "services/ApiServiceProviders";
import { env } from "env";

const history = createBrowserHistory({ window });

export function saveToken(token) {
  const decodedToken = decodeJwt(token);
  setToken(token, decodedToken.exp);

  updateProvidersToken(token);
}

function* initToken({ payload }) {
  const request = auth;
  const { initTokenSuccess: setSuccess, initTokenError: setError } = actions;

  yield requestMiddleware({
    ...payload,
    request,
    setSuccess,
    setError,
    onSuccess: (res) => {
      payload.onSuccess(res);

      const token = res.message;

      saveToken(token);
    }
  });
}

function* shareToken({ payload }) {
  const request = getShareToken;
  const { shareTokenSuccess: setSuccess, shareTokenError: setError } = actions;

  yield requestMiddleware({
    ...payload,
    request,
    setSuccess,
    setError
  });
}

function signOut() {
  if (env.NODE_ENV === "development") {
    console.error("SIGN-OUT in prod mode!");
    // eslint-disable-next-line no-restricted-globals
    const isConfirmed = confirm("Sign out?");
    if (isConfirmed) {
      deleteAuthData();
      history.push("/auth");
      window.location.reload();
    }
  } else {
    deleteAuthData();
    history.push("/auth");
    window.location.reload();
  }
}

export default function* watchSaga() {
  yield takeLatest(actions.initTokenRequest, initToken);
  yield takeLatest(actions.shareTokenRequest, shareToken);
  yield takeLatest(actions.signOutRequest, signOut);
}
